var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-ons-button',{staticClass:"button",on:{"click":function($event){return _vm.pdfWindowOpen()}}},[_vm._v("Catalog")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }